<template>
  <router-view />
</template>

<script>
export default {
  name: 'Root'
};
</script>
